/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import {
  colors,
  Heading,
  HFlow,
  Icon,
  IconImage,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Text,
  Theme,
  useTheme,
} from 'bold-ui'
import { AccordionButton } from 'components/accordion/AccordionButton'
import { AccordionItem, AccordionItemPanel } from 'react-accessible-accordion'
import { isUndefinedOrNull } from 'util/checks'

import { OrigemDados } from './ListaTematicaInformacaoAccordion'

interface ListaTematicaInformacaoAccordionItemProps {
  title: string
  index: number
  totalItems: number
  icon?: IconImage
  conteudoLinha: OrigemDados[]
}

export function ListaTematicaInformacaoAccordionItem(props: Readonly<ListaTematicaInformacaoAccordionItemProps>) {
  const { title, index, totalItems, icon, conteudoLinha } = props

  const theme = useTheme()

  const isFirst = index === 0
  const isLast = index === totalItems - 1

  const styles = createStyles(theme, isFirst, isLast)

  return (
    <AccordionItem css={styles.accordionItem}>
      <AccordionButton style={styles.accordionButton} wrapperStyle={styles.accordionButtonWrapper}>
        <HFlow justifyContent='space-between' alignItems='center'>
          <HFlow alignItems='center' hSpacing={1}>
            {!isUndefinedOrNull(icon) && (
              <span css={styles.initialIcon}>
                <Icon icon={icon} color={colors.gray.c40} size={1.5} />
              </span>
            )}
            <Heading component='span' level={5}>
              {title}
            </Heading>
          </HFlow>
          <Icon icon='angleDown' size={1.5} />
        </HFlow>
      </AccordionButton>
      <AccordionItemPanel>
        <Table style={styles.table}>
          <TableHead>
            <TableRow>
              <TableHeader style={styles.tableHeader}>{isLast ? 'Origem' : 'Tipo de registro'}</TableHeader>
              <TableHeader style={styles.tableHeader}>{isLast ? 'Definição' : 'Origem'}</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {conteudoLinha.map((linha, _) => (
              <TableRow key={linha.tipoRegistro}>
                <TableCell style={styles.cellTipoRegistro}>
                  <Text>{linha.tipoRegistro}</Text>
                </TableCell>
                <TableCell style={styles.cellOrigem}>
                  <Text>{linha.origem}</Text>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionItemPanel>
    </AccordionItem>
  )
}

const createStyles = (theme: Theme, isFirst: boolean, isLast: boolean) => ({
  accordionButtonWrapper: css`
    padding-bottom: 0;
  `,
  accordionButton: css`
    padding: 0.5rem 0.7rem;
    overflow: hidden;
    border: 1px ${theme.pallete.divider} solid;
    background-color: ${isLast ? theme.pallete.gray.c90 : theme.pallete.gray.c100};
    margin: 0;
    margin-top: ${isFirst ? '0' : '-1px'};

    &:hover {
      border: 1px ${theme.pallete.divider} solid;
    }

    &:focus {
      border-radius: 2px;
      position: relative;
      z-index: 1;
    }
  `,
  table: css`
    border-top: 0;
  `,
  tableHeader: css`
    padding: 0.75rem 1rem;
  `,
  cellTipoRegistro: css`
    padding: 0.25rem 1rem;
    width: ${isLast ? '25%' : '40%'};
  `,
  cellOrigem: css`
    padding: 0.25rem 1rem;
    width: ${isLast ? '75%' : '60%'};
  `,
  initialIcon: css`
    margin-left: 0.5rem;
  `,
  accordionItem: css`
    margin-top: ${isLast ? '1rem' : '0'};
  `,
})
